/**
 * Customily gallery perf hints — does not modify Customily scripts or cart flow.
 * - Dawn placeholder stays visible until first Customily image loads (cl-gallery-ready)
 * - Main image: eager + fetchpriority; thumbnails: lazy + retina-aware width
 */
(function () {
  if (!document.body.classList.contains('template-product')) return;

  var SHOPIFY_CDN = 'cdn.shopify.com';
  var READY_CLASS = 'cl-gallery-ready';
  var FALLBACK_MS = 8000;
  var fallbackTimers = new WeakMap();

  function mainMaxWidth() {
    return window.matchMedia('(max-width: 749px)').matches ? 800 : 1100;
  }

  /** Customily rail thumbs render ~72–75px; bump CDN width for retina (CTML defaults to width=80). */
  function thumbMaxWidth() {
    var cssPx = window.matchMedia('(max-width: 749px)').matches ? 72 : 75;
    var dpr = window.devicePixelRatio || 1;
    return Math.min(416, Math.ceil(cssPx * dpr * 1.15));
  }

  function withWidthParam(url, minWidth) {
    if (!url || url.indexOf(SHOPIFY_CDN) === -1) return url;

    var match = url.match(/([?&])width=(\d+)/);
    if (match) {
      var current = parseInt(match[2], 10);
      if (current >= minWidth) return url;
      return url.replace(/([?&])width=\d+/, match[1] + 'width=' + minWidth);
    }

    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'width=' + minWidth;
  }

  function tuneImage(img, isPriority, minWidth) {
    if (!img) return;
    if (img.dataset.clMinWidth === String(minWidth)) return;

    var src = img.getAttribute('src');
    if (src) {
      var tuned = withWidthParam(src, minWidth);
      if (tuned !== src) img.setAttribute('src', tuned);
    }

    var srcset = img.getAttribute('srcset');
    if (srcset && srcset.indexOf(SHOPIFY_CDN) !== -1) {
      img.setAttribute(
        'srcset',
        srcset
          .split(',')
          .map(function (part) {
            var bits = part.trim().split(/\s+/);
            if (!bits[0]) return part;
            return withWidthParam(bits[0], minWidth) + (bits[1] ? ' ' + bits[1] : '');
          })
          .join(', ')
      );
    }

    if (!img.dataset.clLoadingTuned) {
      if (isPriority) {
        img.setAttribute('loading', 'eager');
        img.setAttribute('fetchpriority', 'high');
      } else {
        img.setAttribute('loading', 'lazy');
        img.removeAttribute('fetchpriority');
      }
      img.dataset.clLoadingTuned = '1';
    }

    img.dataset.clMinWidth = String(minWidth);
  }

  function markGalleryReady(gallery) {
    if (!gallery || gallery.classList.contains(READY_CLASS)) return;

    var timer = fallbackTimers.get(gallery);
    if (timer) {
      clearTimeout(timer);
      fallbackTimers.delete(gallery);
    }

    gallery.classList.add(READY_CLASS);
  }

  function scheduleReadyFallback(gallery) {
    if (!gallery || gallery.classList.contains(READY_CLASS) || fallbackTimers.has(gallery)) return;

    fallbackTimers.set(
      gallery,
      setTimeout(function () {
        fallbackTimers.delete(gallery);
        markGalleryReady(gallery);
      }, FALLBACK_MS)
    );
  }

  function waitForFirstImage(gallery) {
    if (!gallery || gallery.classList.contains(READY_CLASS)) return;

    var firstImg = gallery.querySelector('img.customily_gallery_image');
    if (!firstImg) {
      scheduleReadyFallback(gallery);
      return;
    }

    function onReady() {
      markGalleryReady(gallery);
    }

    if (firstImg.complete && firstImg.naturalWidth > 0) {
      onReady();
      return;
    }

    firstImg.addEventListener('load', onReady, { once: true });
    firstImg.addEventListener('error', onReady, { once: true });
    scheduleReadyFallback(gallery);
  }

  function processMainImages(gallery) {
    if (!gallery) return;
    var images = gallery.querySelectorAll('img.customily_gallery_image');
    var mainW = mainMaxWidth();

    for (var i = 0; i < images.length; i++) {
      var slide = images[i].closest('.customily_gallery_slide');
      var isVisible =
        i === 0 ||
        (slide && (slide.classList.contains('active') || slide.style.display !== 'none'));
      tuneImage(images[i], isVisible, mainW);
    }
  }

  function processThumbnails(gallery) {
    if (!gallery) return;
    var thumbs = gallery.querySelectorAll('.customily_gallery_thumbnail img');
    var thumbW = thumbMaxWidth();

    for (var i = 0; i < thumbs.length; i++) {
      var thumb = thumbs[i].closest('.customily_gallery_thumbnail');
      var isActive = i === 0 || (thumb && thumb.classList.contains('active'));
      tuneImage(thumbs[i], isActive, thumbW);
    }
  }

  function processGallery(gallery) {
    if (!gallery) return;
    processMainImages(gallery);
    processThumbnails(gallery);
    waitForFirstImage(gallery);
  }

  function scan() {
    document.querySelectorAll('.customily_gallery').forEach(processGallery);
  }

  scan();

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 1) continue;

        if (node.matches && node.matches('.customily_gallery')) {
          processGallery(node);
        } else if (node.querySelector) {
          var gallery = node.querySelector('.customily_gallery');
          if (gallery) processGallery(gallery);
        }

        if (node.matches && node.matches('img.customily_gallery_image')) {
          var parentGallery = node.closest('.customily_gallery');
          if (parentGallery) processGallery(parentGallery);
        }

        if (node.matches && node.matches('.customily_gallery_thumbnail img')) {
          var thumbGallery = node.closest('.customily_gallery');
          if (thumbGallery) processThumbnails(thumbGallery);
        }
      }
    }
    scan();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
